import { render, staticRenderFns } from "./schoolCoatCount.vue?vue&type=template&id=25f4c7c4&"
import script from "./schoolCoatCount.vue?vue&type=script&lang=js&"
export * from "./schoolCoatCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports